import { render, staticRenderFns } from "./CoozzyPhoneIcon.vue?vue&type=template&id=96626416&scoped=true"
import script from "./CoozzyPhoneIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPhoneIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPhoneIcon.vue?vue&type=style&index=0&id=96626416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96626416",
  null
  
)

export default component.exports